const config = {
    appName: 'MyOwnRoutine',
    company: 'Marquista OU',
    domain: 'myownroutine.com',
    regNum: '16914899',
    address: 'Tuulemae street 5, Lasnamae district, 11411 Tallinn, Harju County',
    country: 'Estonia',
    mailTo: 'support@myownroutine.com',
    phone: '+372 8803281',
    descriptor:'myownroutine Tallinn mwnrtn.com +372 8803281 mwnbill.com +372 8803281 mwnpay.com +372 8803281 myownroutine.com +372 8803281',

    nextPaymentDay: '3rd',
    nextPaymentDayTwo: '7th',
    rebillDaysPrice: '28',
    rebillPrice: '69.49',

    productTrialPrices: [1.95, 9.99],
    productRebillPrices: '69.49',
    productSubscriptionDays: [3, 7],
}

export default config
